import React, { useEffect, useState } from "react";
import { Card, Form, Select, Typography } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Success } from "../../../commons/Messages/Messages";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { VOICE_TRANSLATE_LANGUAGES } from "./voiceLanguages";

const { Text } = Typography;

/** Personal settings every role may change (employees too). Each change is saved at once. */
const Preferences = ({ data, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [voiceTranslateTo, setVoiceTranslateTo] = useState(data?.voiceTranslateTo || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setVoiceTranslateTo(data?.voiceTranslateTo || "");
  }, [data?.voiceTranslateTo]);

  const save = async value => {
    const previous = voiceTranslateTo;
    setVoiceTranslateTo(value);
    setSaving(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/users/me/preferences`,
        { voiceTranslateTo: value },
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      Success(t("Preferences saved"));
      updateParent?.();
    } catch (err) {
      setVoiceTranslateTo(previous);
      generalErrorAlert(err);
    } finally {
      setSaving(false);
    }
  };

  const options = [
    { value: "", label: t("Don't translate (keep the spoken language)") },
    ...VOICE_TRANSLATE_LANGUAGES.map(language => ({
      value: language.value,
      label: t(language.label)
    }))
  ];

  return (
    <Card title={t("Preferences")}>
      <Form layout="vertical">
        <Form.Item
          label={t("Translate voice input into")}
          extra={t(
            "When you dictate, the text is written in this language, whatever language you speak. The recording is written out when you stop speaking."
          )}
        >
          <Select
            value={voiceTranslateTo}
            options={options}
            onChange={save}
            loading={saving}
            disabled={saving}
            style={{ maxWidth: 360 }}
          />
        </Form.Item>
      </Form>
      {voiceTranslateTo && (
        <Text type="secondary">{t("Numbers are kept exactly as you say them.")}</Text>
      )}
    </Card>
  );
};

export default Preferences;
